/**
 * Generate a unique, non-guessable campaign email slug.
 * Format: adjective-noun-4hex (e.g., "swift-falcon-a3f2")
 */
function _generateCampaignSlug(name) {
    const adjectives = ['swift','bold','keen','prime','iron','steel','amber','coral','jade','onyx',
        'sage','nova','apex','blaze','cedar','drift','eagle','frost','grove','hawk'];
    const nouns = ['falcon','raven','summit','ridge','stone','creek','pine','oak','wolf','bear',
        'crest','peak','storm','dusk','dawn','ember','flint','moss','vale','shore'];
    const adj = adjectives[Math.floor(Math.random() * adjectives.length)];
    const noun = nouns[Math.floor(Math.random() * nouns.length)];
    const hex = Math.floor(Math.random() * 0xffff).toString(16).padStart(4, '0');
    return `${adj}-${noun}-${hex}`;
}

export class ProjectStore {
    constructor(db) {
        this._db = db;
        this._collection = db.collection('resume-projects');
        this._unsub = null;
        this._projects = [];
        this._listeners = [];
    }

    subscribeAll() {
        this._unsub = this._collection
            .orderBy('createdAt', 'desc')
            .onSnapshot(snap => {
                this._projects = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                this._notify();
            });
    }

    onChange(fn) { this._listeners.push(fn); }
    getAll() { return this._projects; }
    getById(id) { return this._projects.find(p => p.id === id) || null; }

    async create(name, description, createdBy) {
        // Generate a unique campaign email slug (not guessable)
        const slug = _generateCampaignSlug(name);
        const ref = await this._collection.add({
            name,
            description: description || '',
            selectedPrompts: [],
            ccEmails: [],
            calendarInvitees: [],
            campaignEmail: `raven-${slug}@reply.ravenresume.com`,
            campaignSlug: slug,
            status: 'active',
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            createdBy,
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
        return ref.id;
    }

    async update(id, fields) {
        await this._collection.doc(id).update({
            ...fields,
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
    }

    async remove(id) {
        await this._collection.doc(id).delete();
    }

    dispose() {
        if (this._unsub) this._unsub();
    }

    _notify() {
        for (const fn of this._listeners) fn(this._projects);
    }
}
